// extracted by mini-css-extract-plugin
export var controls = "spinner-module--controls--1_QL7";
export var active = "spinner-module--active--luuej";